import request from '@/utils/request'

// 获取账单详情页面数据
export function fetchGetAllBillingDetails(data) {
  return request({
    url: '/market/report/orders',
    method: 'get',
    params: data,
  })
}
